/*
This contains all paths that are used in the application.
This is necessary so the router can tell what is a valid path from what might be a dealer network location slug, without doing an extra backend call.
 */
export const APP_PATHS = {
  CART: 'cart',
  CHECKOUT: 'checkout',
  ACCOUNT: 'account',
  LOGIN: 'login',
  LOGIN_REDIRECT: 'login-with-redirect',
  CALLBACK: 'callback',
  SEARCH: 'search',
  CSR: 'csr',
  REGISTER: 'register',
  ORDER_TRACKING: 'order-tracking',
  MY_ACCOUNT: 'my-account',
  STORE_LOCATION: 'store-location',
  ABOUT: ['about', 'about-us'],
  TERMS: ['tou', 'terms', 'terms-of-use'],
  PRIVACY: ['privacy', 'privacy-policy'],
  CONTACT: ['contact', 'contact-us'],
  CAMPAIGN: '_cp',
  EFLYER: 'eflyer'
};

// Automatically creates a parallel object with leading slashes for the Router
export const ROUTES = Object.fromEntries(
  Object.entries(APP_PATHS).map(([key, value]) => [
    key,
    Array.isArray(value) ? value.map(p => `/${p}`) : `/${value}`
  ])
);

// Flatten any arrays into a single array of strings for index.js
export const EXCLUDED_BASE_PATHS = Object.values(APP_PATHS).flat();
